import "./chunk-EUXUH3YW.js";

// libs/ui-components/src/lib/modules/icon/icons/x-circle_16.svg.ts
import { svg } from "lit";
var xCircle16Svg = svg`
<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <g clip-path="url(#clip0_6716_7946)">
    <path d="M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M10 6L6 10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M6 6L10 10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </g>
  <defs>
    <clipPath id="clip0_6716_7946">
      <rect width="16" height="16" fill="white"/>
    </clipPath>
  </defs>
</svg>
`;
export {
  xCircle16Svg
};
//# sourceMappingURL=x-circle_16.svg-PAYSKKZ6.js.map
